import React from 'react';
import { string } from 'prop-types';

import CSS from './styles.scss';


const NotificationsViews = ({ rid, reqId, accountType }) => {
  const heContactUs = "https://mhe.my.site.com/macmillanlearning/s/";
  const hsContactUs = "https://mhe.my.site.com/bfwhighschool/s/";
  const contactRedirection = accountType === "HE" ? heContactUs : hsContactUs;
  return (
    <div className={ CSS['container'] }>
      <div className={ CSS['notification'] } role="alert" aria-labelledby="notificationTitle" aria-describedby="notificationDesc">

        <p id="notificationTitle" className={ CSS['text'] }>
          For some reason, we couldn't load your e-Book.
          We're sorry about this! A few things to try:
        </p>

        <ul id="notificationDesc">
          <li className={ CSS['list-item'] }>
            <span>Refresh your browser in 60 seconds.</span>
          </li>
          <li className={ CSS['list-item'] }>
            <span>Go to your course home and try again.</span>
          </li>
        </ul>

        <p className={ CSS['text'] }>
          If these don't work look <a rel="noopener noreferrer" href={ contactRedirection } target="_blank" aria-label="Visit Macmillan Learning Support Center">here</a>.
        </p>
        <div className={ CSS['rid'] }>
          RefId: { rid }, ReqId: { reqId }
        </div>
      </div>
    </div>
  );
};

NotificationsViews.propTypes = {
  rid: string,
  accountType: string
};


export default NotificationsViews;